// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3141":"1d21b8d3","5701":"1d21b8d3"}[chunkId] + ".chunk.css";
};